import {
  type DynamicSize,
  dynamicSizeVariant,
} from 'fitify-ui/src/theme/generated/theme-variables'

import type { ThemeFonts, ThemeSizes } from '../types/theme'

export const themeFonts = {
  genderSpecificFunnel: {
    heading: 'Poppins',
    text: 'Poppins',
  },
} satisfies Record<string, ThemeFonts>

export const themeSizes = {
  genderSpecificFunnel: {
    contentHorizontalPadding: 1,
    contentWidth: 37,
    headerHeight: 4,
  },
} satisfies Record<string, ThemeSizes>

export const dynamicSizes = {
  smallMobile: dynamicSizeVariant['Small Mobile'],
  mobile: dynamicSizeVariant['Large Mobile'],
  desktop: dynamicSizeVariant['Large Desktop'],
} satisfies DynamicSize
